import React, { useState, useRef } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import { Fragment } from "react";
// import Link from "react-router-dom"
import Fade from "react-reveal/Fade";
import { closeModal } from "@redq/reuse-modal";
// import ScrollSpyMenu from "../../components/ScrollSpyMenu";
// import Scrollspy from "react-scrollspy";
// import AnchorLink from "react-anchor-link-smooth-scroll";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { x } from "react-icons-kit/feather/x";
// import LoginModal from "../LoginModal";
import Logo from "../../components/UIElements/Logo";
import Button from "../../components/Button";
import Container from "../../components/UI/Container";

import NavbarUser from "../../layouts/components/navbar/NavbarUser";

import { useNavbarType } from "@hooks/useNavbarType";

import NavbarWrapper, { MenuArea, MobileMenu } from "./navbar.style";

import { navbar } from "../../assets/data/AppCreative";

import Scrl from "scrl";
// import logo from '../../assets/image/appCreative/logo.png'
// import chromeLogo from '@src/assets/images/icons/google-chrome.png'

const CloseModalButton = () => (
  <Button
    className="modalCloseBtn"
    variant="fab"
    onClick={() => closeModal()}
    icon={<i className="flaticon-plus-symbol" />}
  />
);

// Alt close button for modal
const CloseModalButtonAlt = () => (
  <Button
    className="modalCloseBtn alt"
    variant="fab"
    onClick={() => closeModal()}
    icon={<i className="flaticon-plus-symbol" />}
  />
);

const Navbar = (props) => {
  const scrl = useRef();
  // const scrl = new Scrl()
  const scrollTo = (event) => {
    event.preventDefault();

    if (!scrl.current) {
      scrl.current = new Scrl();
    }

    // @ts-ignore
    history.replaceState(null, document.title, event.target.hash);

    // @ts-ignore
    scrl.current.scrollTo(
      // @ts-ignore
      document.getElementById(event.target.hash.replace("#", "")),
      "150"
    );
  };

  const { logoImage, navMenu } = navbar;
  const [state, setState] = useState({
    mobileMenu: false,
  });

  const toggleHandler = (type) => {
    if (type === "menu") {
      setState({
        ...state,
        mobileMenu: !state.mobileMenu,
      });
    }
  };

  const scrollItems = [];

  navMenu.forEach((item) => {
    scrollItems.push(item.path.slice(1));
  });

  const handleRemoveMenu = () => {
    setState({
      ...state,
      mobileMenu: false,
    });
  };

  return (
    <Fragment>
      <div className="w-lg-100 d-justify-between d-flex mh-0">
        <Logo
          href="/"
          logoSrc={logoImage}
          title="App Creative"
          className="main-logo d-lg-flex"
        />

        <MenuArea>
          {/* <ScrollSpyMenu className="menu" menuItems={navMenu} offset={-84} /> */}
          {/* end of main menu */}

          <div className="max-w-6xl px-6 d-none d-lg-block">
            <div className="position-relative d-flex row justify-content-between align-items-center ">
              <div className="flex-1 d-flex align-items-center">
                <div className="visible ml-6 space-x-8 ">
                  <Link
                    to="/"
                    className="inline-flex items-center p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer text-primary text-accents-6"
                  >
                    Home
                  </Link>
                  <Link
                    to="/about"
                    className="inline-flex items-center p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer text-primary text-accents-6"
                  >
                    About
                  </Link>
                  {/* <Link
                    to="/pricing"
                    className="inline-flex items-center p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer text-primary text-accents-6"
                  >
                    Pricing
                  </Link> */}
                  <Link
                    to="/platform"
                    className="inline-flex items-center p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer text-primary text-accents-6"
                  >
                    Platform
                  </Link>
                  <Link
                    to="/pricing"
                    className="inline-flex items-center p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer text-primary text-accents-6"
                  >
                    Pricing
                  </Link>
                  <Link
                to="/articles"
                className="inline-flex items-center p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer text-primary text-accents-6"
                >
                Blog
              </Link>
                  {/* <Link
                    to="/media"
                    className="inline-flex items-center p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer text-primary text-accents-6"
                  >
                    Media
                  </Link> */}

                  {/* <a
                    href="https://finance.yahoo.com/news/wiply-announces-launch-saas-platform-150000540.html"
                    target="_blank" rel="noopener noreferrer"
                    className="inline-flex p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer align-items-center text-primary text-accents-6">
                    Media
                  </a> */}
              
                  <a
                    onClick={scrollTo}
                    href="#contact"
                    className="inline-flex p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer align-items-center text-primary text-accents-6"
                  >
                    Contact
                  </a>
                  <a href="https://platform.wiply.co/signup"
                    className="inline-flex items-center p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer text-primary text-accents-6"
                  >
                    Login/Register
                  </a>
                </div>
              </div>
              {/* <NavbarUser skin={skin} setSkin={setSkin} /> */}
              {/* <div className="flex justify-end flex-1 space-x-8">
            {user ? (
              <Link href="#">
                <a className={s.link} onClick={() => signOut()}>
                  Sign out
                </a>
              </Link>
            ) : (
              <Link href="/signin">
                <a className={s.link}>Sign in</a>
              </Link>
            )}
          </div> */}
            </div>
          </div>

          <Button
            className="bg-transparent menubar"
            icon={
              state.mobileMenu ? (
                <Icon className="bar" icon={x} />
              ) : (
                <Fade>
                  <Icon className="close" icon={menu} />
                </Fade>
              )
            }
            color="#6E6B7B"
            variant="textButton"
            onClick={() => toggleHandler("menu")}
          />
        </MenuArea>

        {/* start mobile menu */}
        <MobileMenu
          className={`mobile-menu ${state.mobileMenu ? "active" : ""}`}
        >
          <Container>
            <div className="d-flex flex-column">
              <Link
                to="/"
                onClick={() => handleRemoveMenu()}
                className="p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer  display-6 d-inline-flex align-items-center text-primary text-accents-6"
              >
                Home
              </Link>

              <Link
                to="/about"
                onClick={() => handleRemoveMenu()}
                className="p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer  display-6 d-inline-flex align-items-center text-primary text-accents-6"
              >
                About
              </Link>

              <Link
                to="/pricing"
                onClick={() => handleRemoveMenu()}
                className="p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer display-6 d-inline-flex align-items-center text-primary text-accents-6"
              >
                Pricing
              </Link>
              <Link
                to="/platform"
                onClick={() => handleRemoveMenu()}
                className="p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer display-6 d-inline-flex align-items-center text-primary text-accents-6"
              >
                Platform
              </Link>
              <Link
                to="/articles"
                onClick={() => handleRemoveMenu()}
                className="p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer display-6 d-inline-flex align-items-center text-primary text-accents-6"
              >
                Blog
              </Link>
              {/* <Link
                to="/media"
                onClick={() => handleRemoveMenu()}
                className="p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer display-6 d-inline-flex align-items-center text-primary text-accents-6"
              >
                Media
              </Link> */}
              {/* <a
                    href="https://finance.yahoo.com/news/wiply-announces-launch-saas-platform-150000540.html"
                    target="_blank" rel="noopener noreferrer"
                    className="p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer display-6 d-inline-flex align-items-center text-primary text-accents-6">
                    Media
                  </a> */}
      
              <a
                onClick={scrollTo}
                href="#contact"
                onClick={() => handleRemoveMenu()}
                className="p-1 font-medium leading-6 transition duration-75 ease-in-out rounded-md cursor-pointer display-6 d-inline-flex align-items-center text-primary text-accents-6"
              >
                Contact
              </a>
            </div>
            {/* {navMenu.map((menu, index) => (
            <li key={`menu_key${index}`}>
              <Link
                href={menu.path}
                // offset={menu.offset}
                // onClick={handleRemoveMenu}
              >
                {menu.label}
              </Link>
            </li>
          ))} */}
            {/* </Scrollspy> */}
            <Button className="btn-primary" title="Try for Free" />
          </Container>
        </MobileMenu>
      </div>
    </Fragment>
  );
};

export default Navbar;
